import React from "react";
//will need to import react-router to route between pages
import logo from "../Assets/logo.png";
import facebook from "../Assets/Social/facebook.png";
import instagram from "../Assets/Social/instagram.png";
import twitter from "../Assets/Social/twitter.png";
import codexmon from "../Assets/Social/codexmon.png";
import github from "../Assets/Social/github.png";
import linkedin from "../Assets/Social/linkedin.png";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <div className="footer">
      <div className="footer-site-links">
        <div className="footer-contact">
          <Link to="/">
            <img src={logo} alt="logo" />
          </Link>
          <a className="footer-tel" href="tel:+1234567890">
            <p>+1 (234) 567-8901</p>
          </a>
          <a href="mailto:support@email.com">
            <p>support@email.com</p>
          </a>
        </div>
        <div className="footer-menu">
          <h3>MENU</h3>
          <ul>
            {/* need react router to route between pages */}
            <li className="footer-menu-item">
              <Link to="/profile">
                <p>Profile</p>
              </Link>
            </li>
          </ul>
        </div>
      </div>
      <div className="footer-social">
        <ul>
          {/* need react router to route between pages */}
          <li className="footer-social-item">
            <a href="https://facebook.com">
              <img src={facebook} alt="facebook logo" />
            </a>
          </li>
          <li className="footer-social-item">
            <a href="https://instagram.com">
              <img src={instagram} alt="instagram logo" />
            </a>
          </li>
          <li className="footer-social-item">
            <a href="https://twitter.com">
              <img src={twitter} alt="twitter logo" />
            </a>
          </li>
        </ul>
      </div>
      <div className="footer-copyright-section">
        <span>&#169; 2022 Gloria Ng. All rights reserved.</span>{" "}
        <span>
        <a href="https://codexmon.github.io/">
          <img className="codexmon" src={codexmon} alt="Codexmon" />
        </a>
        <a href="https://github.com/codexmon">
          <img src={github} alt="Github" />
        </a>
        <a href="https://linkedin.com/in/fengshuigal">
          <img src={linkedin} alt="LinkedIn" />
        </a>
        </span>
        <span>
        <Link className="footer-link" to="/terms">
          Terms and Conditions
        </Link>{" "}
        |{" "}
        <Link className="footer-link" to="/privacy">
          Privacy Policy
        </Link>{" "}
        |{" "}
        <Link className="footer-link" to="/cookies">
          Cookies
        </Link>
        {" "}
        |{" "}
        <Link className="footer-link" to="/contact">
          Contact
        </Link>
        </span>
      </div>
    </div>
  );
};

export default Footer;
